module.exports = __webpack_public_path__ + "static/media/quiz_1.6257bb86.png";